var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.siteIDModel != null)?_c('v-select',{attrs:{"items":_vm.sites,"label":"Сайты"},model:{value:(_vm.siteIDModel),callback:function ($$v) {_vm.siteIDModel=$$v},expression:"siteIDModel"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }